import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/queries';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('cashEventQuery', remoteResource, 'cashEventQueries'))

export default store;
